import React, { useEffect } from "react";
import * as Api from "@modules/api";
import PlaylistCard from "@components/items/display/PlaylistCard";
import {
  getPaginatedPlayLists,
  useAppDispatch,
  useAppSelector,
  useGetMyPlaylists,
} from "@lib/stores";
import AddPlaylistDialog from "@components/layouts/b2c/my-corner/AddPlaylistDialog";
import { renderplaylistCountTitle } from "@pages/content/flowTab/MyLibraryPage";
import { useAppNavigate } from "@utils/hooks/useAppNavigate";
import { getPlaylistsAsync } from "@lib/stores/myLibrary/slices";

const PAGE_SIZE = 20;
const PlaylistsPage = () => {
  const navigate = useAppNavigate();
  const dispatch = useAppDispatch();

  const { meta: playlistMeta } = useGetMyPlaylists();
  const playlistsData = useAppSelector(
    (state) => state.myLibrary.playlists.data
  );

  useEffect(() => {
    dispatch(getPlaylistsAsync());
    getPaginatedPlayLists({
      PageNumber: 1,
      PageSize: PAGE_SIZE,
      SortBy: Api.Server.SortBy.MostRecent,
    });
  }, [dispatch]);

  return (
    <div className="flex h-screen flex-col items-start justify-start gap-5 p-8">
      <div className="flex w-full items-start justify-between">
        <div className="flex items-center justify-start gap-3 text-[20px] font-medium">
          {renderplaylistCountTitle(playlistMeta.totalCount || 0)}
        </div>
        <div className="flex items-center justify-start gap-2">
          <AddPlaylistDialog />
        </div>
      </div>
      <div className="cus-scrollbar-w-none grid grid-cols-1 items-center justify-center gap-4 overflow-y-auto pb-20 sm:grid-cols-2 lg:grid-cols-5 md:grid-cols-4 2xl:grid-cols-7 xl:grid-cols-6">
        {playlistsData.map((item) => (
          <PlaylistCard
            key={item.id}
            item={item}
            onClick={() => navigate("/playlist", { id: item.id })}
          />
        ))}
      </div>
    </div>
  );
};

export default PlaylistsPage;
